import { createRouter, createWebHistory, createWebHashHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'

const routes = [
  { path: '/',      name: 'home',    component: HomeView     },
  { path: '/about', name: 'about',   component: () => import('../views/AboutView.vue') },
  { path: '/logout',name: 'logout',  component: () => import('../views/LogoutView.vue') },
  { path: '/management',name: 'management',  component: () => import('../views/managementView.vue') },
  { path: '/locations',name: 'locations',  component: () => import('../views/LocationsView.vue') },
  { path: '/qrv1',name: 'QRKode',  component: () => import('../views/QRView.vue') },
  { path: '/maps',name: 'Maps',  component: () => import('../views/Maps.vue') },
]

const router = createRouter({
  //history: createWebHistory(process.env.BASE_UR),
  history: createWebHashHistory(),
  routes: routes,
  mode: 'hash'
})

export default router
